import { Navigate, createRoute } from "@tanstack/react-router";
import { HistoryWindowSettings, RoutesSettings } from "@amber/collection/ui";
import { BudgetsSettings, PipelineSettings } from "@amber/operations/ui";
import { ChecksAndPolicies } from "../../views/settings/ChecksAndPolicies";
import { DeletedItems } from "../../views/settings/DeletedItems";
import { SettingsPage } from "../../views/settings/SettingsLayout";
import { rootRoute } from "../root";

export const settingsIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings",
  component: function SettingsIndexRoute() {
    return <Navigate to="/settings/users" replace />;
  },
});

export const budgetsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/budgets",
  component: function BudgetsRoute() {
    return <SettingsPage section="budgets">{() => <BudgetsSettings />}</SettingsPage>;
  },
});

export const historyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/history",
  component: function HistoryRoute() {
    return <SettingsPage section="history">{() => <HistoryWindowSettings />}</SettingsPage>;
  },
});

export const pipelineRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/pipeline",
  component: function PipelineRoute() {
    return <SettingsPage section="pipeline">{() => <PipelineSettings />}</SettingsPage>;
  },
});

export const checksRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/checks",
  component: function ChecksRoute() {
    return <SettingsPage section="checks">{() => <ChecksAndPolicies />}</SettingsPage>;
  },
});

export const routesSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/routes",
  component: function RoutesRoute() {
    return <SettingsPage section="routes">{() => <RoutesSettings />}</SettingsPage>;
  },
});

export const deletedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings/deleted",
  component: function DeletedRoute() {
    return <SettingsPage section="deleted">{() => <DeletedItems />}</SettingsPage>;
  },
});
